// extracted by mini-css-extract-plugin
module.exports = {"page":"_901628e","title":"_2e2b758"};